const TAB_ORDER = ["information", "notes", "purchase-orders", "bills"];

const setFieldValue = (form, name, value) => {
    const field = form?.elements.namedItem(name);
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) {
        return;
    }

    field.value = value ?? "";
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
};

const copyPhysicalAddress = (editor) => {
    const form = editor.querySelector("[data-supplier-profile-form]");
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const pairs = [
        ["Supplier.PhysicalAddressLine1", "Supplier.PostalAddressLine1"],
        ["Supplier.PhysicalAddressLine2", "Supplier.PostalAddressLine2"],
        ["Supplier.PhysicalCity", "Supplier.PostalCity"],
        ["Supplier.PhysicalRegion", "Supplier.PostalRegion"],
        ["Supplier.PhysicalPostalCode", "Supplier.PostalPostalCode"],
        ["Supplier.PhysicalCountry", "Supplier.PostalCountry"]
    ];

    pairs.forEach(([sourceName, targetName]) => {
        const source = form.elements.namedItem(sourceName);
        if (source instanceof HTMLInputElement || source instanceof HTMLTextAreaElement || source instanceof HTMLSelectElement) {
            setFieldValue(form, targetName, source.value);
        }
    });
};

const activateTab = (editor, requestedTab, focus = false) => {
    const tabs = [...editor.querySelectorAll("[data-supplier-tab]")];
    const enabledTabs = tabs.filter((tab) => !tab.disabled);
    const selectedTab = enabledTabs.find((tab) => tab.dataset.supplierTab === requestedTab) ?? enabledTabs[0];
    if (!selectedTab) {
        return;
    }

    tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle("is-active", isSelected);
        tab.setAttribute("aria-selected", isSelected ? "true" : "false");
        tab.tabIndex = isSelected ? 0 : -1;
    });

    editor.querySelectorAll("[data-supplier-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.supplierPanel !== selectedTab.dataset.supplierTab;
    });

    if (focus) {
        selectedTab.focus();
    }
};

export const setupSupplierEditors = (root = document) => {
    root.querySelectorAll("[data-supplier-editor]").forEach((editor) => {
        if (editor.dataset.supplierEditorReady === "true") {
            return;
        }

        editor.dataset.supplierEditorReady = "true";
        activateTab(editor, editor.dataset.initialTab || "information");

        editor.addEventListener("click", (event) => {
            const tab = event.target.closest("[data-supplier-tab]");
            if (tab && !tab.disabled) {
                activateTab(editor, tab.dataset.supplierTab);
                return;
            }

            if (event.target.closest("[data-supplier-copy-address]")) {
                copyPhysicalAddress(editor);
            }
        });

        editor.addEventListener("keydown", (event) => {
            const current = event.target.closest("[data-supplier-tab]");
            if (!current || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
                return;
            }

            const enabledTabs = TAB_ORDER
                .map((tabName) => editor.querySelector(`[data-supplier-tab="${tabName}"]`))
                .filter((tab) => tab && !tab.disabled);
            const currentIndex = enabledTabs.indexOf(current);
            if (currentIndex < 0) {
                return;
            }

            event.preventDefault();
            let nextIndex = currentIndex;
            if (event.key === "Home") nextIndex = 0;
            if (event.key === "End") nextIndex = enabledTabs.length - 1;
            if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % enabledTabs.length;
            if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length;
            activateTab(editor, enabledTabs[nextIndex].dataset.supplierTab, true);
        });
    });
};
